import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface PreloaderProps {
  onComplete: () => void;
}

type Phase = 'video' | 'done';

export default function Preloader({ onComplete }: PreloaderProps) {
  const [phase, setPhase] = useState<Phase>('video');

  useEffect(() => {
    const t1 = setTimeout(() => { setPhase('done'); onComplete(); }, 3500);
    return () => clearTimeout(t1);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase !== 'done' && (
        <motion.div
          className="fixed inset-0 z-[9999] overflow-hidden"
          style={{ background: '#080808' }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
        >
          <motion.video
            autoPlay muted loop playsInline
            className="absolute inset-0 w-full h-full object-cover"
            src="/videos/Honey_Drip.mp4"
            onError={() => {}}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse at center, transparent 35%, rgba(8,8,8,0.6) 100%)' }}
          />
          {/* Progress bar */}
          <div className="absolute bottom-0 left-0 right-0" style={{ height: 2, background: 'rgba(212,175,55,0.1)' }}>
            <motion.div
              style={{ height: '100%', background: 'rgba(212,175,55,0.6)', boxShadow: '0 0 8px rgba(212,175,55,0.4)' }}
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{ duration: 3.5, ease: 'linear' }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
